import apis from "../../core/apis.js";

class BackupResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.backup).get(options);
  }
  getAvailableBackups(options) {
    return this.$resource(`${apis.ride}${options.id}/available_backups`).get(
      options
    );
  }

  get(id) {
    return this.$resource(apis.backup + id).get();
  }

  search(search = "") {
    return this.$resource(apis.backup).get({ search });
  }

  post(item) {
    return this.$resource(apis.backup).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.backup + id + `/${name}`).save(item);
  }

  update(id, item) {
    return this.$resource(apis.backup + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  arrive(id, station) {
    return this.$resource(apis.backup + id + "/arrive_station").save(station);
  }

  schedule(id, station) {
    return this.$resource(apis.backup + id + "/schedule_station").save(station);
  }

  start(id) {
    return this.$resource(apis.backup + id + "/start").save();
  }

  end(id) {
    return this.$resource(apis.backup + id + "/end").save();
  }

  cancel(id) {
    return this.$resource(apis.backup + id + "/cancel").save();
  }

  nearBy(id) {
    return this.$resource(apis.backup + id + "/nearby_stations").get();
  }

  getBackupRecommendation(id) {
    return this.$resource(apis.backup + "backup_recommendations/" + id).get();
  }

  refreshBackupRecommendation(id, item) {
    return this.$resource(
      apis.backup + "backup_recommendations/" + id + "refresh",
      null,
      {
        update: { method: "PUT" },
      }
    ).update(item);
  }
}

export default BackupResource;



// WEBPACK FOOTER //
// ./src/resources/backup/backup.resource.js